import {
	HomeIntro,
	HomeOutro,
	DefaultPageIntro,
	DefaultPageOutro,
	CondensedPageIntro,
	CondensedPageOutro,
	SiteIntro,
	BurgerOpen,
	BurgerClose
} from './anims';

import { InitPlanView, HideOverlay, ZoomIn, ZoomOut, ZoomReset } from './planView';
import { InitMap, NavigateAmenitySlide, CleanAmenityGallery } from './mapGallery';
import { InitInteriorGallery, NavigateInteriorSlide, CleanInteriorGallery } from './interiorGallery';

let params = {};
let firstTime = true;
let isBurgerOpen = false;
let map = null;

Init();
PageInit(GetPageName());

window.addEventListener('scroll', (e) => {
	if (params.parallaxImages.length > 0) {
		params.parallaxImages.map((img) => ParallaxScroll(img));
	}
});

function Init() {
	$('#main').smoothState({
		debug: true,
		prefetch: true,
		cacheLength: 4,
		onStart: {
			duration: 600,
			render: ($container) => {
				QueryParams();
				CleanAmenityGallery();
				const pageName = GetPageName();
				params.pageName = pageName;
				console.log(pageName);
				//outro goes here
				OutroAnim(pageName);
			}
		},
		onAfter: ($container, $newContent) => {
			const pageName = GetPageName();
			params.pageName = pageName;
			QueryParams();
			//intro goes here
			PageInit(pageName);
		}
	});
}

function QueryParams() {
	params = {
		main: document.querySelector('.main'),
		homeTransition: document.querySelector('.home-transition'),
		transitionWipe: document.querySelector('.transition-wipe'),
		nav: document.querySelector('.nav'),
		contentHeaderBlock: document.querySelector('.content-header-block'),
		fadeElements: [ ...document.querySelectorAll('.fade') ],
		content: document.querySelector('.content'),
		parallaxImages: [ ...document.querySelectorAll('.parallax') ],
		map: document.querySelector('.map'),
		gallery: document.querySelector('.gallery'),
		galleryImage: document.querySelector('.gallery-image'),
		galleryTitle: document.querySelector('.slide-heading'),
		galleryThumbCont: document.querySelector('.thumb-container'),
		floorSelector: document.querySelector('.floor-selector-list'),
		floorPlanView: document.querySelector('.floor-plan-view'),
		overlay: document.querySelector('.overlay'),
		burger: document.querySelector('.burger'),
		burgerIcon: document.querySelector('.nav-item-burger'),
		burgerBg: document.querySelector('.burger-bg'),
		burgerList: document.querySelector('.burger-list'),
		burgerButton: document.querySelector('.nav-item-burger'),
		navLogo: document.querySelector('.nav-item-logo')
	};
}

export function GetPageName() {
	const rawName = window.location.pathname.split('/').pop();
	let pageName = rawName.split('.').shift();
	if (pageName === '') pageName = 'index';
	return pageName;
}

function PageInit(_page) {
	//intro anims and stuff go here
	QueryParams();
	// InitAmenityGallery(params);
	InitPlanView(params);

	switch (_page) {
		case 'index':
			if (firstTime) {
				SiteIntro(params);
				firstTime = false;
			} else {
				HomeIntro(params);
			}
			return;
		case 'building':
		case 'location':
			firstTime = false;
			DefaultPageIntro(params);
			InitMap(params);
			// InitMap(params);
			return;
		case 'contact':
			firstTime = false;
			DefaultPageIntro(params);
			return;
		case 'concierge':
		case 'floor-plans':
			firstTime = false;
			CondensedPageIntro(params);
			InitInteriorGallery(params);
			return;
		case 'specification':
			firstTime = false;
			CondensedPageIntro(params);
			return;
	}
}

function OutroAnim(_page) {
	QueryParams();
	//outro anim fires here
	switch (_page) {
		case 'index':
			HomeOutro(params);
			return;
		case 'location':
			CleanAmenityGallery();
			DefaultPageOutro(params);
			return;
		case 'building':
		case 'contact':
			DefaultPageOutro(params);
			return;
		case 'concierge':
		case 'floor-plans':
			CleanInteriorGallery();
			return;
		case 'specification':
			CondensedPageOutro(params);
			return;
	}
}

export function NavigateSlide(dir) {
	NavigateGallery(dir);
}

export function NavigateAmenitySlideHandler(dir) {
	NavigateAmenitySlide(dir);
}

export function NavigateInteriorSlideHandler(dir) {
	NavigateInteriorSlide(dir);
}

export function CloseOverlayHandler() {
	HideOverlay();
}

function ParallaxScroll(img) {
	img.style.backgroundPosition = `50% ${-img.getBoundingClientRect().y / 3}px`; //was 3
}

export function ZoomHandler(dir) {
	switch (dir) {
		case 'in':
			ZoomIn();
			return;
		case 'out':
			ZoomOut();
			return;
		case 'reset':
			ZoomReset();
			return;
	}
}

export function ToggleBurger() {
	if (isBurgerOpen) {
		isBurgerOpen = false;
		BurgerClose(params);
	} else {
		isBurgerOpen = true;
		BurgerOpen(params);
	}
}



// WEBPACK FOOTER //
// ./src/main.js